import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import {ControlRoomTableStateProperties, createBasicTableComponent} from "../common/ui/table/ControlRoomTable";
import {isFinished} from "../common/util/asyncdata/reducerUtil";
import {AOIColumns} from "./AOIColumns";
import {AOINotificationArea} from "./model";
import {selectors} from "./selectors";

const INNER_PANEL_ON_DRAWER_PADDING = 24;

export const aoiListDimensions = (parent: HTMLElement) => {
    return {
        width: parent.clientWidth - INNER_PANEL_ON_DRAWER_PADDING * 2,
        height: 300,
    };
};

export const AOIListComponent = createBasicTableComponent(AOIColumns, aoiListDimensions);

interface AOIListProps {
    userId: string;
    clearSelection: boolean;
}

const mapStateToProps = (state, ownProps: AOIListProps): ControlRoomTableStateProperties<AOINotificationArea> => {
    const notifications = selectors.getAllNotifications(state);
    const user = notifications.find(n => n.id === ownProps.userId);

    return {
        data: user?.triggers || [],
        isPaged: false,
        isAllDataLoaded: isFinished(selectors.getNotificationRequestState(state)),
        noItemsFoundMessage: <FormattedMessage id="studio.notifications.aoi.no-items" defaultMessage="No AOI found."/>,
        clearSelection: ownProps.clearSelection,
    };
};

export const AOIList = connect(mapStateToProps)(injectIntl(AOIListComponent));